/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PermissionsInputs */

const en_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

const ar_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصلاحيات`)
};

const bn_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পারমিশন`)
};

const de_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen`)
};

const es_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos`)
};

const fr_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations`)
};

const pt_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões`)
};

const zh_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限`)
};

const tr_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzinler`)
};

const ru_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешения`)
};

const pl_svchip_permissions = /** @type {(inputs: Svchip_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uprawnienia`)
};

/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Svchip_PermissionsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_permissions = /** @type {((inputs?: Svchip_PermissionsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PermissionsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_permissions(inputs)
	if (locale === "bn") return bn_svchip_permissions(inputs)
	if (locale === "de") return de_svchip_permissions(inputs)
	if (locale === "es") return es_svchip_permissions(inputs)
	if (locale === "fr") return fr_svchip_permissions(inputs)
	if (locale === "pt") return pt_svchip_permissions(inputs)
	if (locale === "zh") return zh_svchip_permissions(inputs)
	if (locale === "tr") return tr_svchip_permissions(inputs)
	if (locale === "ru") return ru_svchip_permissions(inputs)
	if (locale === "pl") return pl_svchip_permissions(inputs)
	return en_svchip_permissions(inputs)
});